class BerriFeaturedProductPromoSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    if (this.swiper) return;

    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', () => this.initSwiper(), { once: true });
      return;
    }

    const slider = this.querySelector('.berri-featured-product__promo-slider');
    if (!slider) return;

    const prevButton = this.querySelector('.berri-featured-product__promo-nav .slider-button--prev');
    const nextButton = this.querySelector('.berri-featured-product__promo-nav .slider-button--next');

    this.swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      breakpoints: {
        990: {
          slidesPerView: 1.701,
          spaceBetween: 10,
        },
      },
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('berri-featured-product-promo-slider')) {
  customElements.define('berri-featured-product-promo-slider', BerriFeaturedProductPromoSlider);
}
